export default "__VITE_ASSET__C3Dm_C$$__"